import * as React from "react";
import TooltipComponent from "./TooltipComponent";

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
library.add(faQuestionCircle);

interface IProps {
    children: any,
}

class HelpTooltip extends React.PureComponent<IProps> {
    render() {
        const element: React.ReactElement = (
            <span className="ll-help-tooltip">
                <FontAwesomeIcon icon="question-circle" />
            </span>
        )
        return (
            <TooltipComponent
                element={element}
                tooltip={this.props.children}
                uncontrolled
            />
        );
    }
}

export default HelpTooltip;
